module.exports = __webpack_public_path__ + "img/sb_br_zj.794aa17d.png";